module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-mv.2347fd0c.png";